import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "experiencias",
  class: "container-fluid custom-experiencias"
}
const _hoisted_2 = { class: "row justify-content-center py-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bold text-center mb-5 px-md-3 h3" }, "EXPERIENCIAS")
], -1)
const _hoisted_4 = { class: "col-10" }
const _hoisted_5 = { class: "row row-cols-auto justify-content-center" }
const _hoisted_6 = { class: "card h-100 bg-transparent" }
const _hoisted_7 = { class: "card-body d-flex flex-column justify-content-between" }

import { onMounted, ref } from 'vue'
import VCardImageWithText from './VCardImageWithText.vue'
import useSitio from '@/composables/useSitio'
import { Skeletor } from 'vue-skeletor'
import sleep from '@/utils/Sleep'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheExperiencias',
  props: {
    total: null
  },
  setup(__props: any) {

const props = __props as {
  total: number
};



const isLoading = ref(true)
const { getExperiencias } = useSitio()

const experiencias = ref<
  {
    actividadId: number
    nombre: string
    bajada: string
    descripcion: string
    imagen: string
    titulo: string
  }[]
>([])

// Simular carga de datos
onMounted(async () => {
  isLoading.value = true
  await sleep(1)
  const data = await getExperiencias()
  experiencias.value = data
  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (isLoading.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.total, (index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-12 col-lg-6 mb-4"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(Skeletor), {
                      type: "rect",
                      width: "100%",
                      height: "280px",
                      class: "rounded-3 placeholder"
                    }),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_unref(Skeletor), {
                        type: "text",
                        width: "60%",
                        height: "20px",
                        class: "small rounded-3 mb-1"
                      }),
                      _createVNode(_unref(Skeletor), {
                        type: "text",
                        width: "80%",
                        height: "30px",
                        class: "rounded-3 small mb-3"
                      }),
                      _createVNode(_unref(Skeletor), {
                        type: "button",
                        width: "150px",
                        height: "40px",
                        class: "rounded-3"
                      })
                    ])
                  ])
                ]))
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(experiencias.value, (item) => {
                return (_openBlock(), _createBlock(VCardImageWithText, {
                  key: item.actividadId,
                  imagen: item.imagen ?? '',
                  titulo: item.nombre,
                  subtitlo: item.bajada,
                  texto: item.descripcion,
                  id: item.actividadId
                }, null, 8, ["imagen", "titulo", "subtitlo", "texto", "id"]))
              }), 128))
        ])
      ])
    ])
  ]))
}
}

})